module.exports = __webpack_public_path__ + "img/map_bg.4edcb492.jpg";